export const PRODUCT_KEY = {
  INDEX: 'productIndex',
  ID: 'productId',
  NAME: 'productName',
  IMAGES: 'images',
  ATTRIBUTES: 'attributes',
  PART_NO: 'productPartNo',
  SPEC_NAME: 'productSpecName',
  SPEC_SELECTED_VALUE: 'productSpecSelectedValue',
  AVAILABLE_COUNT: 'proudctAvailableCount',
  STOCK: 'proudctStock',
  SPEC_VISIBLE: 'productVisible',
  ATTR: 'productAttr',
  BARCODE: 'productBarcode',
  ITEM_INDEX: 'itemProductIndex',
  ITEM_ID: 'itemProductId',
  ITEM_NAME: 'itemProductName',
  ITEM_PART_NO: 'itemProductPartNo',
  ITEM_SPEC_NAME: 'itemProductSpecName',
  ITEM_SPEC_SELECTED_VALUE: 'itemProductSpecSelectedValue',
  ITEM_STOCK: 'itemProudctStock',
  ITEM_AVAILABLE_COUNT: 'itemProudctAvailableCount',
  ITEM_SPEC_VISIBLE: 'itemProductVisible',
  ITEM_ATTR: 'itemProductAttr',
  ITEM_BARCODE: 'itemProductBarcode',
  IS_NEW: 'isNew',
  EDITABLE: 'editable',
  NEW_PRODUCT_IMAGES: 'newProductImages'
}

export const LISTING_KEY_MAP = {
  [PRODUCT_KEY.ID]: 'sku',
  [PRODUCT_KEY.NAME]: 'name',
  [PRODUCT_KEY.PART_NO]: 'partNo',
  [PRODUCT_KEY.SPEC_NAME]: 'spec.name',
  [PRODUCT_KEY.SPEC_SELECTED_VALUE]: 'spec.selectedValue',
  [PRODUCT_KEY.AVAILABLE_COUNT]: 'availableCount',
  [PRODUCT_KEY.STOCK]: 'stock',
  [PRODUCT_KEY.BARCODE]: 'barcode',
  [PRODUCT_KEY.SPEC_VISIBLE]: 'isVisible',
  [PRODUCT_KEY.ATTRIBUTES]: 'attributes',
  [PRODUCT_KEY.ITEM_ID]: 'item.sku',
  [PRODUCT_KEY.ITEM_NAME]: 'item.name',
  [PRODUCT_KEY.ITEM_PART_NO]: 'item.partNo',
  [PRODUCT_KEY.ITEM_SPEC_NAME]: 'item.spec.name',
  [PRODUCT_KEY.ITEM_SPEC_SELECTED_VALUE]: 'item.spec.selectedValue',
  [PRODUCT_KEY.ITEM_STOCK]: 'item.stock',
  [PRODUCT_KEY.ITEM_AVAILABLE_COUNT]: 'item.availableCount',
  [PRODUCT_KEY.ITEM_BARCODE]: 'item.barcode',
  [PRODUCT_KEY.ITEM_SPEC_VISIBLE]: 'item.isVisible'
}

export const ONE_LAYER_PRODUCT_KEY_MAP = {
  [PRODUCT_KEY.ID]: 'sku',
  [PRODUCT_KEY.NAME]: 'name',
  [PRODUCT_KEY.PART_NO]: 'partNo',
  [PRODUCT_KEY.SPEC_NAME]: 'spec.name',
  [PRODUCT_KEY.SPEC_SELECTED_VALUE]: 'spec.selectedValue',
  [PRODUCT_KEY.STOCK]: 'stock',
  [PRODUCT_KEY.AVAILABLE_COUNT]: 'availableCount',
  [PRODUCT_KEY.BARCODE]: 'barcode',
  [PRODUCT_KEY.ATTRIBUTES]: 'attributes'
}

export const TWO_LAYER_PRODUCT_KEY_MAP = {
  [PRODUCT_KEY.SPEC_NAME]: 'parentSpec.name',
  [PRODUCT_KEY.SPEC_SELECTED_VALUE]: 'parentSpec.selectedValue',
  [PRODUCT_KEY.ITEM_ID]: 'sku',
  [PRODUCT_KEY.ITEM_NAME]: 'name',
  [PRODUCT_KEY.ITEM_PART_NO]: 'partNo',
  [PRODUCT_KEY.ITEM_SPEC_NAME]: 'spec.name',
  [PRODUCT_KEY.ITEM_SPEC_SELECTED_VALUE]: 'spec.selectedValue',
  [PRODUCT_KEY.ITEM_STOCK]: 'stock',
  [PRODUCT_KEY.ITEM_AVAILABLE_COUNT]: 'availableCount',
  [PRODUCT_KEY.ITEM_BARCODE]: 'barcode',
  [PRODUCT_KEY.ATTRIBUTES]: 'attributes'
}

export const ONE_LAYER_ATTRS = [
  PRODUCT_KEY.ID,
  PRODUCT_KEY.NAME,
  PRODUCT_KEY.PART_NO,
  PRODUCT_KEY.SPEC_NAME,
  PRODUCT_KEY.SPEC_SELECTED_VALUE,
  PRODUCT_KEY.STOCK,
  PRODUCT_KEY.BARCODE,
  PRODUCT_KEY.SPEC_VISIBLE,
  PRODUCT_KEY.ATTR,
  PRODUCT_KEY.AVAILABLE_COUNT,
  PRODUCT_KEY.ATTRIBUTES
]

export const TWO_LAYER_ATTRS = [
  PRODUCT_KEY.ITEM_ID,
  PRODUCT_KEY.ITEM_NAME,
  PRODUCT_KEY.ITEM_PART_NO,
  PRODUCT_KEY.ITEM_SPEC_NAME,
  PRODUCT_KEY.ITEM_SPEC_SELECTED_VALUE,
  PRODUCT_KEY.ITEM_STOCK,
  PRODUCT_KEY.ITEM_BARCODE,
  PRODUCT_KEY.ITEM_SPEC_VISIBLE,
  PRODUCT_KEY.ITEM_ATTR,
  PRODUCT_KEY.ITEM_AVAILABLE_COUNT,
  PRODUCT_KEY.ATTRIBUTES
]

export const ERROR_CODE = {
  INVALID_PRODUCT_ID: 40009149
}

export const PRODUCTS_MAX_SIZE = {
  ONE_LAYER: {
    ATTR: 30
  },
  TWO_LAYER: {
    PARENT_ATTR: 20,
    ATTR: 30
  }
}

export const TABLE_TIP_KEY = 'tableTip'

export const REMOVE_MODE_TABLE_TIP_KEY = 'removeModeTableTip'

export const OVER_LIMIT_SUBMIT_ERROR_KEY = 'OVER_LIMIT_SUBMIT_ERROR_KEY'

export const REMOVE_MODE_ERROR_KEY = 'REMOVE_MODE_ERROR_KEY'

export const LISTING_CHANGE_STATUS = {
  SAME: 'same',
  DIFF: 'diff',
  FAIL: 'fail'
}

export const PRODUCT_MODAL_TYPE = {
  VISIBLE: 'visible',
  DELETE: 'delete',
  NEW: 'new'
}

export const LAYER_CHANGED_DEFAULT_SKU = -1
